import { render, staticRenderFns } from "./WarningTipList.vue?vue&type=template&id=dee8268e"
import script from "./WarningTipList.vue?vue&type=script&lang=js"
export * from "./WarningTipList.vue?vue&type=script&lang=js"
import style0 from "./WarningTipList.vue?vue&type=style&index=0&id=dee8268e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports